var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organism-creator"},[_c('MoleculesPortfolioMoleculeCreator',_vm._l((_vm.creatorData),function(creator,index){return _c('AtomsPortfolioAtomCreator',{key:index,attrs:{"image":_vm.resourceUrl(creator.image),"name":creator.name,"urlLinkedin":creator.urlLinkedin}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }